import Service from "./../../Libs/Service";

import SetupSettings from "./../settings/settings.json";

// Авторизация по токену. Токен выдаёт сервер после входа через Google/LinkedIn
// (или через /auth/dev в режиме локальной разработки), приходит в url-фрагменте и хранится в localStorage.
// Сессии и куки нужны только для плавного перехода: если у пользователя осталась старая сессия,
// сервер один раз выдаёт по ней токен (см. loadSessionToken).
// Кроме токена сервер сообщает ноду, на которой живёт аккаунт пользователя (номер и адрес): в кластере
// дашборда нод несколько, и клиент должен подключаться именно к своей (см. Documents/Cluster.txt).
let Auth = new Service({

	Name: "Auth",

	Actions: {

		// Сервер выдал новый токен (например когда супер-админ переключился на другого пользователя)
		"AuthToken": function(token) {

			this.setToken(token);

		},

		// Список пользователей всех онлайн-нод для локального входа (ответ на действие GetDevUsers)
		"DevUsers": function(users) {

			this.devUsers = users || [];

			Broadcast.call("Dev Users Received");

		}

	},

	Events: {

	},

	init() {

		this.storageKey = 'mraid-auth-token';

		// Нода, на которой живёт аккаунт пользователя, и её адрес для клиента
		this.serverStorageKey = 'mraid-auth-server';
		this.serverAddressStorageKey = 'mraid-auth-server-address';

		// Адрес ноды, с которой загрузился клиент: нужен чтобы вернуться к нему после выхода
		this.defaultDomain = SetupSettings.domain;

		this.loginNotice = null;

		// Причина неудачного входа, пришедшая в url-фрагменте (#loginError=...)
		this.loginError = null;

		// Пользователи для локального входа (кнопка "Sign in as developer")
		this.devUsers = [];

		this.readUrlData();

		// Если аккаунт пользователя живёт на другой ноде, все запросы клиента идут на неё
		this.applyServerAddress();

	},

	// Данные авторизации приходят в url-фрагменте (#token=...&server=...&serverAddress=...&loginNotice=...),
	// а причина неудачного входа - как #loginError=... (см. redirectLoginError на сервере).
	// Фрагмент url не отправляется на сервер, поэтому токен не попадает в логи.
	readUrlData() {

		if (location.hash.indexOf('token=') === -1 && location.hash.indexOf('loginError=') === -1) return;

		let params = new URLSearchParams(location.hash.substr(1));

		if (params.get('token')) this.setToken(params.get('token'));

		// Нода, на которой живёт аккаунт пользователя: может отличаться от ноды, с которой загрузился клиент
		if (params.get('server')) this.setServer(params.get('server'), params.get('serverAddress'));

		// Причину неудачного входа показываем на экране авторизации (например, нода аккаунта недоступна)
		if (params.get('loginError')) this.loginError = params.get('loginError');

		if (params.get('loginNotice')) {

			try {

				this.loginNotice = JSON.parse(params.get('loginNotice'));

			} catch (e) {

				this.loginNotice = null;

			}

		}

		// Убираем токен из адресной строки
		history.replaceState(null, '', location.pathname + location.search);

	},

	getToken() {

		return localStorage.getItem(this.storageKey);

	},

	setToken(token) {

		localStorage.setItem(this.storageKey, token);

	},

	clearToken() {

		localStorage.removeItem(this.storageKey);
		localStorage.removeItem(this.serverStorageKey);
		localStorage.removeItem(this.serverAddressStorageKey);

		// Возвращаем адрес ноды, с которой загрузился клиент
		this.applyServerAddress();

	},

	// Номер ноды, на которой живёт аккаунт пользователя (номер из таблицы metadata_servers)
	getServerId() {

		return parseInt(localStorage.getItem(this.serverStorageKey), 10) || null;

	},

	// Адрес ноды аккаунта для клиента (без протокола, например localhost:83 в режиме разработки).
	// Если клиент загружен с самой ноды аккаунта, адрес со входом не передавался - берём адрес загрузки
	getServerAddress() {

		let address = localStorage.getItem(this.serverAddressStorageKey);

		if (address) return address;

		return this.defaultDomain;

	},

	// Адрес ноды кластера для клиента (без протокола). В разработке у каждой ноды свой порт,
	// в продакшене внешний порт закрывает nginx (Documents/Cluster.txt)
	getNodeAddress(serverId) {

		let server = Metadata.Servers[serverId];

		if (!server) return this.getServerAddress();

		if (SetupSettings.dev) return `${server.domain}:${server.port}`;

		return server.domain;

	},

	// Полный адрес ресурса на ноде, с которой сейчас работает клиент (нода выбранного паблишера).
	// Нужен там, где в шаблоне ссылка относительная: без адреса ноды браузер запросил бы файл
	// у ноды загрузки клиента, а данные паблишера живут только на его ноде
	getNodeUrl(path) {

		return this.getNodeUrlForServer(Server.getDefaultServerId(), path);

	},

	// Полный адрес ресурса на указанной ноде кластера. Нужен там, где на экране сразу данные нескольких
	// нод (например список паблишеров всех нод): файл лежит на ноде своего паблишера
	getNodeUrlForServer(serverId, path) {

		return `${location.protocol}//${this.getNodeAddress(serverId)}${path}`;

	},

	setServer(serverId, address) {

		if (!serverId) return;

		localStorage.setItem(this.serverStorageKey, serverId);

		if (address) localStorage.setItem(this.serverAddressStorageKey, address);

		this.applyServerAddress();

	},

	// Адрес ноды аккаунта подставляем в общие настройки клиента: сокет-соединение клиента идёт
	// на ноду с данными пользователя. Http запросы позже переключаются на ноду выбранного паблишера
	// (applyWorkingServerAddress)
	applyServerAddress() {

		SetupSettings.domain = this.getServerAddress();

	},

	// Нода, с данными которой сейчас работает клиент - нода выбранного паблишера. По ней строятся все
	// http ссылки дашборда (файлы, превью, ассеты и скрипты): данные паблишера живут только на его ноде.
	// Нода аккаунта при этом остаётся нодой первичного сокет-соединения (Documents/Cluster.txt)
	applyWorkingServerAddress(serverId) {

		SetupSettings.domain = this.getNodeAddress(serverId);

	},

	// Забираем уведомление о входе (показывается один раз)
	consumeLoginNotice() {

		let loginNotice = this.loginNotice;

		this.loginNotice = null;

		return loginNotice;

	},

	// Плавный переход с авторизации по куке на токены: если токена ещё нет, но у пользователя осталась
	// старая сессия, сервер выдаст по ней токен (запрос идёт на тот же домен, поэтому кука отправляется сама)
	loadSessionToken(next) {

		if (this.getToken()) return next();

		fetch('/auth/token', {headers: {Accept: 'application/json'}})
			.then(response => response.ok ? response.json() : null)
			.then(data => {

				if (data && data.token) this.setToken(data.token);

				next();

			})
			.catch(() => next());

	},

	// Подписываем http запрос токеном
	authorizeRequest(xhr) {

		let token = this.getToken();

		if (token) xhr.setRequestHeader('Authorization', `Bearer ${token}`);

	},

	// Заголовки авторизации для fetch запросов
	getAuthHeaders() {

		let token = this.getToken();

		if (!token) return {};

		return {Authorization: `Bearer ${token}`};

	},

	// Добавляем токен в url для ссылок, картинок и окон, которые браузер открывает сам
	addTokenToUrl(url) {

		let token = this.getToken();

		if (!token) return url;

		return `${url}${url.indexOf('?') === -1 ? '?' : '&'}token=${encodeURIComponent(token)}`;

	}

});

window.Auth = Auth;

export { Auth }
